import {css} from "@panda/css";

import {CONSULTANT_PHONE_DISPLAY, CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";

export const RegistrationWizardHotlineInfo = () => {
    return (
        <>
            Nie otrzymałeś kodu? Skontaktuj się z naszym biurem obsługi:{" "}
            <a href={CONSULTANT_PHONE_HREF} className={hotlineLinkStyle}>
                {CONSULTANT_PHONE_DISPLAY}
            </a>
        </>
    );
};

const hotlineLinkStyle = css({
    color: "inherit",
    fontWeight: 700
});
import {css} from "@panda/css";

import {CONSULTANT_PHONE_DISPLAY, CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";

export const RegistrationWizardHotlineInfo = () => {
    return (
        <>
            Nie otrzymałeś kodu? Skontaktuj się z naszym biurem obsługi:{" "}
            <a href={CONSULTANT_PHONE_HREF} className={hotlineLinkStyle}>
                {CONSULTANT_PHONE_DISPLAY}
            </a>
        </>
    );
};

const hotlineLinkStyle = css({
    color: "inherit",
    fontWeight: 700
});
